export * from 'server/models/PSixVesselDimension';


// WEBPACK FOOTER //
// ./data/models/PSixVesselDimension.ts